import { INITIALIZE_ROLE } from './types';
export function initializeRole(payload) {
    return {
        type: INITIALIZE_ROLE,
        payload: payload
    };
}
 
